import { useState } from "react";
import csv2json from 'csvjson-csv2json';
import LeadsService from "../Services/LeadsService";
import SequenceService from "../Services/SequenceService";
import ModalService from "../Services/ModalService";
import PubSub from 'pubsub-js';
import { MODAL_ADD_LEADS_FROM_LIST } from "../constants";

function AddLeadsModal({ sequence_id, onLeadsAdded }) {
    const [leadsText, setLeadsText] = useState('');
    const [loading, setLoading] = useState(false);

    function mapLeads() {
        return csv2json(leadsText, { parseNumbers: true });
    }

    async function onAddLeads() {
        let leadsMapped = mapLeads();
        let leadsWithEmail = leadsMapped.filter(lead => lead.email);
        if (!leadsWithEmail.length) {
            PubSub.publish('show-basic-notification', {
                title: 'Error',
                message: 'No leads with email found'
            });
            return;
        }

        setLoading(true);
        await LeadsService.uploadLeadsUsingJSON(leadsWithEmail);
        await SequenceService.assignLeadsToSequence(sequence_id);
        setLoading(false);
        ModalService.closeAddLeadsModal();
        PubSub.publish('show-basic-notification', {
            title: 'Leads added',
            message: 'Leads uploaded and assigned'
        });
        if (onLeadsAdded) onLeadsAdded();
    }

    function hideModal() {
        ModalService.closeAddLeadsModal();
    }

    return (
        <div>
            <div className="modal fade" id={MODAL_ADD_LEADS_FROM_LIST} tabIndex="-1" aria-labelledby={MODAL_ADD_LEADS_FROM_LIST} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header modal-add-leads-header">
                            <i className="fas fa-user-plus me-2"></i>
                            <div>
                                <h6 className="modal-title bold">Add leads</h6>
                                <p className="modal-subtitle fs-14 text-muted">Paste your leads data below to upload and assign them.</p>
                            </div>


                            <button type="button" className="btn-close fs-12" onClick={hideModal}></button>
                        </div>
                        <div className="modal-body">
                            <div className="fs-14 mb-2">
                                Use this <a href="https://docs.google.com/spreadsheets/d/1igqND-RBpMiugcFK0rXyV0Jff7unnx8wa1QsbbhEgGQ/edit?gid=0" target="_blank" rel="noreferrer">template</a> to format your leads data before pasting it below.
                            </div>
                            <p className="small">Or upload a CSV file</p>
                            <input
                                type="file"
                                className="form-control mb-3"
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    if (!file) return;
                                    let reader = new FileReader();
                                    reader.onload = function (ev) {
                                        setLeadsText(ev.target.result);
                                    }
                                    reader.readAsText(file);
                                }}
                            />
                            <textarea
                                rows="8"
                                value={leadsText}
                                onChange={(e) => setLeadsText(e.target.value)}
                                className="form-control fs-14 mb-3">
                            </textarea>
                            <button
                                disabled={!leadsText || loading}
                                onClick={onAddLeads}
                                className="btn btn-primary btn-sm">
                                {loading && <i className="fas fa-spinner fa-spin me-2"></i>}
                                Load leads
                            </button>
                        </div>
                        <div className="modal-footer">
                            <button onClick={hideModal} className="btn btn-secondary btn-sm fs-13">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddLeadsModal;
